/* mv-product.js — Jewellery by JF PDP behaviour, externalized from sections/mv-product.liquid.
   Loaded with `defer` from the section. Every Liquid-interpolated value (section id,
   low-stock threshold, shop.money_format, i18n strings) arrives through the
   <script type="application/json" data-mv-product-config> block rendered inside each
   section — parsed here with JSON.parse. Variant data is read from the section's
   existing <script type="application/json" data-mvp-variants> block. Each section is
   scoped independently (self-init per config block) so multiple products on one page
   never collide.

   Add-to-cart is intentionally NOT handled here. The product form and the sticky add
   button (form="...") both submit the same product form, which is intercepted globally
   by assets/mv-cart.js — it POSTs to /cart/add, shows the toast, updates
   [data-mv-cart-count] and flashes the button. An inline fetch here would double-add. */
(function () {
  // Format cents using the storefront's money_format (mirrors mv-wishlist.liquid),
  // so JS-updated prices match Shopify's server-rendered `| money` output exactly.
  function money(cents, moneyFormat) {
    var amount = (Number(cents) / 100);
    var parts = amount.toFixed(2).split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = intPart + '.' + parts[1];
    var withoutDecimals = intPart;
    var out = moneyFormat || '${{amount}}';
    out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withoutDecimals);
    out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals);
    out = out.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withoutDecimals);
    out = out.replace(/\{\{\s*amount\s*\}\}/g, withDecimals);
    return out;
  }

  function initSection(root, config) {
    var MVP_LOW_T = parseInt(config.lowStockThreshold, 10) || 3;
    var MONEY_FORMAT = config.moneyFormat || '${{amount}}';
    var STR = config.strings || {};
    var dataEl = root.querySelector('[data-mvp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var idInput = root.querySelector('[data-mvp-variant-id]');
    var priceEl = root.querySelector('[data-mvp-price]');
    var compareEl = root.querySelector('[data-mvp-compare]');
    var stickyPrice = root.querySelector('[data-mvp-sticky-price]');
    var stockWrap = root.querySelector('[data-mvp-stock]');
    var stockText = root.querySelector('[data-mvp-stock-text]');
    var submitBtn = root.querySelector('[data-mvp-submit]');
    var submitText = root.querySelector('[data-mvp-submit-text]');
    var gallery = root.querySelector('.mvp-gallery');

    function swapFeatured(v) {
      if (!v || !gallery) return;
      var mid = (v.featured_media && v.featured_media.id) || v.featured_image && v.featured_image.id;
      if (!mid) return;
      var cell = gallery.querySelector('[data-mvp-media-id="' + mid + '"]');
      if (!cell) return;
      // bring the variant's featured media to the front (top-left / first in the mobile carousel)
      gallery.insertBefore(cell, gallery.firstChild);
      if (window.matchMedia && window.matchMedia('(max-width:749px)').matches) {
        cell.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-mvp-option-index]').forEach(function (o) {
        var idx = parseInt(o.getAttribute('data-mvp-option-index'), 10);
        var active = o.querySelector('.mvp-sw.active, .mvp-size.active');
        if (active) opts[idx - 1] = active.getAttribute('data-mvp-value');
      });
      return opts;
    }

    function matchVariant(opts) {
      if (!variants.length) return null;
      if (!opts.length) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function update() {
      var v = matchVariant(selectedOptions());
      if (!v) {
        if (submitBtn) { submitBtn.disabled = true; submitText.textContent = STR.unavailable; }
        if (idInput) idInput.removeAttribute('value');
        return;
      }
      if (idInput) { idInput.value = v.id; idInput.disabled = !v.available; }
      swapFeatured(v);
      if (priceEl) priceEl.textContent = money(v.price, MONEY_FORMAT);
      if (stickyPrice) stickyPrice.textContent = money(v.price, MONEY_FORMAT);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price, MONEY_FORMAT);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
      if (v.available) {
        if (submitBtn) { submitBtn.disabled = false; submitText.textContent = STR.addToBag; }
      } else {
        if (submitBtn) { submitBtn.disabled = true; submitText.textContent = STR.soldOut; }
      }
      // real-inventory-driven stock label (mirrors the server-side logic in the section)
      var st = 'in';
      if (!v.available) { st = 'out'; }
      else if (v.inventory_management === 'shopify') {
        if (v.inventory_quantity <= 0) { st = 'order'; }
        else if (v.inventory_quantity <= MVP_LOW_T) { st = 'low'; }
      }
      if (stockWrap) { stockWrap.classList.toggle('out', st === 'out'); stockWrap.classList.toggle('low', st === 'low'); }
      if (stockText) {
        if (st === 'out') { stockText.textContent = STR.outOfStock; }
        else if (st === 'order') { stockText.textContent = STR.madeToOrder; }
        else if (st === 'low') { stockText.textContent = String(STR.onlyLeft || '').replace('__N__', v.inventory_quantity); }
        else { stockText.textContent = STR.inStock; }
      }
      root.querySelectorAll('[data-mvp-option-index]').forEach(function (o) {
        var active = o.querySelector('.mvp-sw.active, .mvp-size.active');
        var lbl = o.querySelector('[data-mvp-optval]');
        if (active && lbl) lbl.textContent = active.getAttribute('data-mvp-value');
      });
    }

    root.querySelectorAll('[data-mvp-option-index]').forEach(function (o) {
      o.querySelectorAll('.mvp-sw, .mvp-size').forEach(function (el) {
        function select() {
          o.querySelectorAll('.mvp-sw, .mvp-size').forEach(function (x) { x.classList.remove('active'); });
          el.classList.add('active');
          update();
        }
        el.addEventListener('click', select);
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            if (e.key === ' ' || e.key === 'Spacebar') e.preventDefault();
            select();
          }
        });
      });
    });

    var qtyEl = root.querySelector('[data-mvp-qty]');
    var qtyInput = root.querySelector('[data-mvp-qty-input]');
    function setQty(n) { n = Math.max(1, n); if (qtyEl) qtyEl.textContent = n; if (qtyInput) qtyInput.value = n; }
    var qd = root.querySelector('[data-mvp-qty-down]'), qu = root.querySelector('[data-mvp-qty-up]');
    if (qd) qd.addEventListener('click', function () { setQty(parseInt(qtyEl.textContent, 10) - 1); });
    if (qu) qu.addEventListener('click', function () { setQty(parseInt(qtyEl.textContent, 10) + 1); });

    root.querySelectorAll('.mvp-acc .q').forEach(function (q) {
      function toggleAcc() {
        var open = q.parentElement.classList.toggle('open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      q.addEventListener('click', toggleAcc);
      q.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          if (e.key === ' ' || e.key === 'Spacebar') e.preventDefault();
          toggleAcc();
        }
      });
    });

    // ---- Image lightbox / zoom preview ------------------------------------
    // The gallery cells are plain <img> in a grid with no click behaviour, so
    // tapping a photo did nothing. Wire every image cell to open a centred
    // floating card, on top of the page, with prev/next navigation. Video /
    // model / external_video cells keep their native controls and are skipped.
    //
    // The overlay lives on <body> (outside the section) so its CSS is injected
    // here as a <style> tag rather than in the section's {% stylesheet %} —
    // that bundle is cached separately and left the appended <div> unstyled,
    // dropping it into normal flow at the bottom of the page.
    (function initLightbox() {
      if (!gallery) return;
      function imageCells() {
        var out = [];
        gallery.querySelectorAll('.mvp-cell').forEach(function (cell) {
          var type = cell.getAttribute('data-mvp-media-type');
          if (type === 'video' || type === 'model' || type === 'external_video') return;
          var img = cell.querySelector('img');
          if (img) out.push(img);
        });
        return out;
      }
      var imgs = imageCells();
      if (!imgs.length) return;

      // Bump a Shopify CDN url to a crisper width for the zoomed view.
      function fullSrc(img) {
        var best = img.currentSrc || img.src || '';
        return best.replace(/([?&]width=)\d+/, '$11600');
      }

      if (!document.getElementById('mvp-lb-styles')) {
        var st = document.createElement('style');
        st.id = 'mvp-lb-styles';
        st.textContent =
          'html.mvp-lb-open{overflow:hidden}' +
          '.mvp-lb{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;' +
            'background:rgba(20,18,15,.72);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);' +
            'padding:clamp(16px,4vw,56px);animation:mvp-lb-fade .18s ease}' +
          '.mvp-lb[hidden]{display:none}' +
          '.mvp-lb-card{position:relative;background:#fff;border-radius:14px;overflow:hidden;' +
            'max-width:min(92vw,760px);max-height:90vh;box-shadow:0 30px 80px rgba(0,0,0,.45);' +
            'display:flex;flex-direction:column;animation:mvp-lb-pop .2s cubic-bezier(.2,.8,.3,1)}' +
          '.mvp-lb-img{display:block;max-width:100%;max-height:calc(90vh - 8px);object-fit:contain;background:#f4f0ea}' +
          '.mvp-lb-close{position:absolute;top:12px;right:12px;width:38px;height:38px;border:0;border-radius:50%;' +
            'background:rgba(255,255,255,.9);color:#1c1a17;font-size:22px;line-height:1;cursor:pointer;' +
            'box-shadow:0 2px 10px rgba(0,0,0,.18);transition:background .2s}' +
          '.mvp-lb-close:hover{background:#fff}' +
          '.mvp-lb-nav{position:absolute;top:50%;transform:translateY(-50%);width:42px;height:42px;border:0;' +
            'border-radius:50%;background:rgba(255,255,255,.9);color:#1c1a17;font-size:24px;line-height:1;' +
            'cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.18);transition:background .2s}' +
          '.mvp-lb-nav:hover{background:#fff}' +
          '.mvp-lb-nav.prev{left:12px}.mvp-lb-nav.next{right:12px}' +
          '.mvp-lb-count{position:absolute;bottom:12px;left:50%;transform:translateX(-50%);' +
            'background:rgba(20,18,15,.6);color:#fff;font-size:12px;letter-spacing:.08em;' +
            'padding:4px 10px;border-radius:20px}' +
          '.mvp-lb-close:focus-visible,.mvp-lb-nav:focus-visible{outline:2px solid #1c1a17;outline-offset:2px}' +
          '@keyframes mvp-lb-fade{from{opacity:0}to{opacity:1}}' +
          '@keyframes mvp-lb-pop{from{opacity:0;transform:scale(.96)}to{opacity:1;transform:scale(1)}}' +
          '@media(max-width:749px){.mvp-lb-card{max-width:94vw}.mvp-lb-nav{width:36px;height:36px;font-size:20px}}';
        document.head.appendChild(st);
      }

      var lb = document.createElement('div');
      lb.className = 'mvp-lb';
      lb.setAttribute('data-mvp-lb', '');
      lb.hidden = true;
      lb.innerHTML =
        '<div class="mvp-lb-card" role="dialog" aria-modal="true" aria-label="' + (STR.close || 'Image preview') + '">' +
          '<button type="button" class="mvp-lb-close" aria-label="' + (STR.close || 'Close') + '">&times;</button>' +
          '<button type="button" class="mvp-lb-nav prev" aria-label="' + (STR.previous || 'Previous') + '">&#8249;</button>' +
          '<img class="mvp-lb-img" alt="">' +
          '<button type="button" class="mvp-lb-nav next" aria-label="' + (STR.next || 'Next') + '">&#8250;</button>' +
          '<div class="mvp-lb-count" aria-hidden="true"></div>' +
        '</div>';
      document.body.appendChild(lb);

      var lbImg = lb.querySelector('.mvp-lb-img');
      var lbCount = lb.querySelector('.mvp-lb-count');
      var prevBtn = lb.querySelector('.prev');
      var nextBtn = lb.querySelector('.next');
      var closeBtn = lb.querySelector('.mvp-lb-close');
      var current = 0;
      var lastFocus = null;

      function render() {
        // Re-read cells each time so variant-driven reordering is respected.
        imgs = imageCells();
        if (!imgs.length) return;
        if (current < 0) current = imgs.length - 1;
        if (current >= imgs.length) current = 0;
        var src = imgs[current];
        lbImg.src = fullSrc(src);
        lbImg.alt = src.alt || '';
        var multi = imgs.length > 1;
        prevBtn.hidden = nextBtn.hidden = !multi;
        lbCount.hidden = !multi;
        if (multi) lbCount.textContent = (current + 1) + ' / ' + imgs.length;
      }
      function open(i) {
        current = i;
        lastFocus = document.activeElement;
        render();
        lb.hidden = false;
        document.documentElement.classList.add('mvp-lb-open');
        closeBtn.focus();
      }
      function close() {
        lb.hidden = true;
        document.documentElement.classList.remove('mvp-lb-open');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function go(delta) { current += delta; render(); }

      imgs.forEach(function (img) {
        img.closest('.mvp-cell').classList.add('mvp-zoomable');
        img.addEventListener('click', function () { open(imageCells().indexOf(img)); });
      });

      prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
      nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
      closeBtn.addEventListener('click', close);
      // Backdrop click (outside the card) closes.
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') go(-1);
        else if (e.key === 'ArrowRight') go(1);
      });
    })();

    // Load the related-products row from Shopify's recommendation engine (intent: related).
    // The endpoint re-renders THIS section with the `recommendations` object populated, so we
    // fetch it, parse out the grid, and swap it in. On empty/error we keep whatever
    // server-rendered on first paint (real recommendations, the same-collection fallback,
    // or nothing at all — never invented placeholder products).
    var recsWrap = root.querySelector('[data-mvp-recs="related"]');
    var recsUrl = recsWrap && recsWrap.getAttribute('data-mvp-recs-url');
    if (recsUrl) {
      fetch(recsUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshGrid = doc.querySelector('[data-mvp-recs="related"] [data-mvp-recs-grid]') ||
            doc.querySelector('[data-mvp-recs-grid]');
          var curGrid = recsWrap.querySelector('[data-mvp-recs-grid]');
          if (freshGrid && curGrid && freshGrid.children.length) {
            curGrid.innerHTML = freshGrid.innerHTML;
            // First paint may have hidden the row (no truthful cards to show yet). Real
            // cards have now landed, so reveal it.
            recsWrap.removeAttribute('hidden');
            recsWrap.style.removeProperty('display');
          }
        })
        .catch(function () { /* keep the server-rendered fallback grid on error */ });
    }

    update();
  }

  function boot() {
    var configs = document.querySelectorAll('[data-mv-product-config]');
    for (var i = 0; i < configs.length; i++) {
      var cfgEl = configs[i], config;
      try { config = JSON.parse(cfgEl.textContent); } catch (e) { continue; }
      var root = cfgEl.closest('[data-section-id]') ||
        document.querySelector('[data-section-id="' + config.sectionId + '"]');
      if (root) initSection(root, config);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
